import React from 'react';
import Button from '../../../../../../../../../../../../../../../../components/button';
import {isDirectoryV5AccessPopupShown as setIsDirectoryV5AccessPopupShown} from '../../../../../../../../../../../../../../../../../actions/popupActions';
import {useDispatch, useSelector} from 'react-redux';

function EditContactButton ({contactId, selectedLabelId, contactType, disabled, title, history}) {

	const profile = useSelector(state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

    const handleClick = (e) => {
        e.stopPropagation();

	    if(contactType === "directory"){
		    if(profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false){
			    dispatch(setIsDirectoryV5AccessPopupShown(true));
		    } else {
			    history.push('/contact/' + contactId + '/edit');
		    }
	    } else {
		    history.push('/contact/' + contactId + '/edit');
	    }
    };

	return (
		<Button
			className="btn-link"
			title={title || ''}
			data-contact-id={contactId}
			data-contact-type={contactType}
			onClick={ handleClick }
			disabled={disabled}
		>
			<div className="more-option-item__picto">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path fill="none" d="M0 0h24v24H0V0z"/>
					<path
						fill="currentColor"
						d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"/>
				</svg>
			</div>
			<div className="more-option-item__text">
				<span>{title}</span>
			</div>
		</Button>
	);
}

export default EditContactButton;
